import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useCountry } from "../context/CountryContext";

// The old /nigeria page used static data. Nigeria is now a country selection that filters the
// normal Products page, so this route just switches to Nigeria and sends the visitor there.
// Any existing links or bookmarks to /nigeria keep working.
export default function NigeriaProducts() {
  const { setCountry } = useCountry();

  useEffect(() => {
    setCountry("Nigeria");
  }, [setCountry]);

  return <Navigate to="/products" replace />;
}